import { useMutation } from "@tanstack/vue-query";
import { useApi } from "./useApi";
import { useToaster } from "./useToaster";

interface DeleteResponse {
  success: boolean;
  message: string;
}

interface ApiError {
  response?: {
    status?: number;
    data?: {
      message?: string;
    };
  };
}

export function useMediaDeleteMutation() {
  const api = useApi();
  const toaster = useToaster();

  return useMutation({
    mutationFn: async (mediaId: string) => {
      return await api.media.delete({ params: { media: mediaId } }) as DeleteResponse;
    },
    retry: (failureCount, error) => {
      const apiError = error as ApiError;
      
      // Don't retry authorization errors
      if (apiError?.response?.status === 403) {
        return false;
      }
      
      // Retry network errors up to 2 times
      if (!apiError?.response) {
        return failureCount < 2;
      }
      
      return false;
    },
    retryDelay: (attemptIndex) => {
      return Math.min(1000 * Math.pow(2, attemptIndex), 10000);
    },
    onError: (error) => {
      const apiError = error as ApiError;
      let message = "Failed to delete media";
      
      if (apiError?.response?.status === 403) {
        message = "Unauthorized to delete this media";
      } else if (!apiError?.response) {
        message = "Delete failed. Please check your connection.";
      } else if (apiError?.response?.data?.message) {
        message = apiError.response.data.message;
      }
      
      toaster.create({
        title: message,
        type: "error",
      });
    },
  });
}



